import { render, staticRenderFns } from "./BigModal.vue?vue&type=template&id=7962be7f&"
import script from "./BigModal.vue?vue&type=script&lang=js&"
export * from "./BigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BigModal.vue"
export default component.exports